module.exports = __webpack_public_path__ + "static/media/cu04_jpn.1539c3be.png";